export const environment = {
  production: false,
  application: 'DEVELOPMENT',
  baseUrl: 'https://smartgas-v2-panel.dev.api.smartgas.global',
  notificationUrl: 'https://notification-service.dev.api.smartgas.global',
  reportUrl: 'https://report-service.dev.api.smartgas.global',
  mapsApiUrl: 'https://locator.dev.api.smartgas.global',
  logsApiUrl: 'https://log-service.dev.api.smartgas.global',
  dispatcherApiUrl: 'https://sg-backend.dev.api.smartgas.global',
  mobileFuelSensorUrl: 'https://sg-backend.dev.api.smartgas.global',
  yandexMapsApiKey: '22ca9d4d-ab0e-410d-8c99-076a9f749374',
  yandexSuggestApiKey: '7e3200ea-448a-4f19-8477-7c89180ecad2',
  // Адреса фронтендов, а не API: карта и сама панель. Раньше были
  // захардкожены в коде, из-за чего dev-сборка вела на боевые.
  mapsFrontUrl: 'https://locator-front.dev.smartgas.global',
  panelFrontUrl: 'https://smartgas-v2-panel.dev.smartgas.global',
};
